import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OnboardingMediaRBAC = {
  pageID: '15116696a86dfbea54ad55378f5c903a',
  elementID: {
    View: '31debcd06955aeca4d8f345debe43c0d',
    SaveProductCarousel: 'db570968dd94d51db1353a071fcd21ec',
    DeleteProductCarousel: '49ca9c9edca0155540dd029f309fe4be',
    SaveLottieBackground: '1cc8664da6da3153e47d89951227fa64',
  },
} as const

export const useRBACOnboardingMediaPage = createUseRBAC(OnboardingMediaRBAC.elementID)

export type UseRBACOnboardingMediaPageType = ReturnType<typeof useRBACOnboardingMediaPage>
